import { gql } from "apollo-boost";

export const GET_DEPARTMENT = gql`
  query getDepartment($id: ID!) {
    getDepartment(
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  query getDepartments {
    getDepartments {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const ADD_DEPARTMENT = gql`
  mutation addDepartment(
    $code: String!,
    $nameLocal: String!,
    $nameEng: String
  ) {
    addDepartment (
      code: $code,
      nameLocal: $nameLocal,
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_DEPARTMENT = gql`
  mutation updateDepartment(
    $id: ID!,
    $code: String!,
    $nameLocal: String!,
    $nameEng: String
  ) {
    updateDepartment (
      id: $id,
      code: $code,
      nameLocal: $nameLocal,
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_DEPARTMENT = gql`
  mutation deleteDepartment(
    $id: ID!
  ) {
    deleteDepartment (
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

